import { render, staticRenderFns } from "./TextareaVariable.vue?vue&type=template&id=5a4d1498&scoped=true"
import script from "./TextareaVariable.vue?vue&type=script&lang=js"
export * from "./TextareaVariable.vue?vue&type=script&lang=js"
import style0 from "./TextareaVariable.vue?vue&type=style&index=0&id=5a4d1498&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4d1498",
  null
  
)

export default component.exports